import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=68e5ad9d&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style0 from "./Products.vue?vue&type=style&index=0&id=68e5ad9d&prod&lang=scss"
import style1 from "./Products.vue?vue&type=style&index=1&id=68e5ad9d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e5ad9d",
  null
  
)

export default component.exports